/**
 * Smooth Scroll Behavior Polyfill
 */
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

/**
 * Modules
 */
import "./modules/closestPolyfill.js";
import BodyScroll from "./modules/BodyScroll.js";
import { slideUp, slideDown, slideToggle } from "./modules/slideBlock.js";

window.addEventListener("DOMContentLoaded", function () {
  /**
   * Set Full Window Height
   */
  const setWindowHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.querySelector(":root").style.setProperty("--vh", `${vh}px`);
  };
  setWindowHeight();

  window.addEventListener("resize", () => {
    setWindowHeight();
  });

  /**
   * Init BodyScroll
   */
  const bodyScroll = new BodyScroll();

  /**
   * Nav
   */
  const hamburger = document.querySelector(".hamburger");
  const nav = document.querySelector("nav.header-nav");
  hamburger?.addEventListener("click", () => {
    if (hamburger.classList.contains("is-active")) {
      bodyScroll.unLock(300);
    } else {
      bodyScroll.lock(nav);
    }

    hamburger.classList.toggle("is-active");
    nav?.classList.toggle("active");
  });

  const subNavTriggers = document.querySelectorAll(
    ".header-nav li.menu-item-has-children > a"
  );
  subNavTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      if (window.innerWidth < 992) {
        trigger.classList.toggle("active");
        slideToggle(trigger.nextElementSibling, 300);
      }
    });
  });

  /**
   * To Top
   */
  const toTop = document.querySelector(".footer-to-top");
  toTop?.addEventListener("click", () => {
    document.body.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });

  /**
   * Course
   */
  const course = document.querySelector(".course");
  if (course) {
    const coursBlocks = course.querySelectorAll(".course-block"),
      courseNavItems = course.querySelectorAll(".course-nav li a");

    courseNavItems.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const target = document.querySelector(link.hash);
        let offset = 24;

        if (target) {
          const scrollY = window.scrollY,
            blockOffsetTop = target.getBoundingClientRect().top + scrollY,
            scrollDistance = blockOffsetTop - offset;

          window.scroll({
            top: scrollDistance,
            left: 0,
            behavior: "smooth",
          });
        }
      });
    });

    window.addEventListener("scroll", () => {
      const fromTop = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      );

      courseNavItems.forEach((link) => {
        const target = document.querySelector(link.hash);

        if (target) {
          if (
            target.offsetTop <= fromTop + 300 &&
            target.offsetTop + target.offsetHeight > fromTop + 300
          ) {
            link.classList.add("active");
          } else {
            link.classList.remove("active");
          }
        }
      });
    });
  }

  /**
   * FAQ
   */
  const courseFaqBlocks = document.querySelectorAll(".course-faq-block");
  courseFaqBlocks.forEach((block) => {
    const trigger = block.querySelector(".course-faq-block-trigger");
    const dropdown = block.querySelector(".course-faq-block-dropdown");

    trigger.addEventListener("click", () => {
      trigger.classList.toggle("active");
      slideToggle(dropdown, 300);
    });
  });

  /**
   * SaaS All In One
   */
  const saasAllInOneBlocks = document.querySelectorAll('.saas-all-in-one-block')
  saasAllInOneBlocks.forEach((block, index) =>{
    const trigger = block.querySelector('.saas-all-in-one-block-trigger'),
        content = block.querySelector('.saas-all-in-one-block-content')

    trigger.addEventListener('click', ()=>{
      if(!trigger.classList.contains('active')){
        const activeItemTrigger = document.querySelector('.saas-all-in-one-block-trigger.active');
        
        if(activeItemTrigger){
          activeItemTrigger.classList.remove('active');
          activeItemTrigger.nextElementSibling.classList.remove('active');
        }
      } 
      
      trigger.classList.toggle('active')
      content.classList.toggle('active')
    });

    if(index === 0){
      trigger.classList.add('active')
      content.classList.add('active')
    }
  });
  
});
